import { SerializedConstructor } from '@langchain/core/load/serializable';

import { cn } from '@/utils/tailwind';

import { Message } from '../Message';
import { EvaluatorType, useEvaluatorStore } from './store/evaluatorStore';
import { EvaluatorCrudFormProps } from './types';
import { useMessagePreviews } from './utils/useMessagePreviews';

export const PromptPreview = (
  props: EvaluatorCrudFormProps & {
    manifest: SerializedConstructor;
    evaluatorType: EvaluatorType;
  }
) => {
  const variableMapping = useEvaluatorStore((state) => state.variableMapping);
  const messages = useMessagePreviews({
    manifest: props.manifest,

    variableMapping: variableMapping ?? {},
    input: props.input ?? {},
    output: props.output ?? {},
    referenceOutput: props.referenceOutput ?? {},
    fewShotDatasetId: props.fewShotDatasetId,
  });

  return (
    <div className="flex flex-col gap-2">
      {messages.map(([role, content, isError]) => (
        <Message
          key={role}
          content={content}
          role={role}
          className={cn(
            isError ? 'border border-error' : 'hover:border-primary',
            props.evaluatorType === 'hub' && 'bg-secondary text-tertiary'
          )}
          omitMaxHeight={true}
        />
      ))}
    </div>
  );
};
